/// CONFIG ///

const CONFIG = {
    APP_TITLE:      'EcoSupplier',
    API_IP: 		'',
    API_DOMAIN: 	'https://api.ecomarket.ru/',
    API_C_DOMAIN: 	'https://api.ecomarket.ru/',
    API_GATE: 		'https://api.ecomarket.ru/api.php',
    COOKIE_TITLE: 	'eco_supplier'
};

export default CONFIG;